import { render, staticRenderFns } from "./DiagnosticAnswer.vue?vue&type=template&id=47762746&scoped=true"
import script from "./DiagnosticAnswer.vue?vue&type=script&lang=js"
export * from "./DiagnosticAnswer.vue?vue&type=script&lang=js"
import style0 from "./DiagnosticAnswer.vue?vue&type=style&index=0&id=47762746&prod&lang=scss"
import style1 from "./DiagnosticAnswer.vue?vue&type=style&index=1&id=47762746&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47762746",
  null
  
)

export default component.exports